import { QRCodeSVG } from 'qrcode.react'
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useMetaStore } from '../store/MetaStore'

const ShareEventView = () => {
  const setPageTitle = useMetaStore((state) => state.setPageTitle)
  const eventId = useMetaStore((state) => state.eventId)

  useEffect(() => {
    setPageTitle('Share Link')
  }, [setPageTitle])

  if (!eventId) {
    return <Navigate to="/error" replace />
  }

  const currentOrigin = window.location.origin

  let updatedUrl = currentOrigin
  if (currentOrigin.includes('localhost')) {
    updatedUrl = currentOrigin.replace('localhost', '192.168.86.58')
  }

  return (
    <div
      style={{
        display: 'grid',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '40px',
        }}
      >
        <div
          style={{
            background: 'white',
            padding: '10px',
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          }}
        >
          <QRCodeSVG value={updatedUrl} size={200} />
        </div>
        <div style={{ marginTop: '20px', fontSize: '1.2em', color: '#555' }}>
          {updatedUrl}
        </div>
      </div>
    </div>
  )
}

export default ShareEventView
